<template>
  <div class="container">
    <v-text-field
      label="Email"
      type="text"
      v-model="email"
    />
    <v-text-field
      label="Senha"
      type="password"
      v-model="senha"
    />
    <v-btn 
      color="success"
      @click="entrar"
    >Entrar</v-btn>
  </div>
</template>

<script>
import axios from 'axios'
import sha256 from 'js-sha256'

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      senha: ''
    }
  },
  methods: {
    async entrar() {
      try {
        const response = await axios.post('https://api.socialplace.com.br/api/login', {
          email: this.email.trim(),
          password: sha256(this.senha.trim()),
          object_type: 0,
          facebook_login: '',
          origin: 'painel_login'
        })
        const data = response.data
        if (data.ok && data.data.admin) {
          const d = new Date()
          d.setDate(d.getDate() + 1)
          localStorage.setItem('token', data.data.token)
          localStorage.setItem('validate', d.getTime())

          this.$emit('sucesso')
          return
        }
        throw { message: 'Erro no login' }
      }
      catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style scoped>
.container {
  width: 30%;
  margin-top: 100px;
}
</style>